var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    fill: "gold",
    viewBox: "0 0 297.142 297.142"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.685 147.071h-33.544V127.41c0-7.149-5.517-13.339-12.667-13.339h-3.333v-24a8 8 0 0 0-16 0v24h-1.83c-7.15 0-15.795 5.309-19.212 11.59l-11.362 20.975-50.929.305c-9.3 0-38.916 8.768-65.693 17.334l-16.641-16.203H16.142v26.976c-9 3.3-16.142 5.524-16.142 5.524s7.142 2.274 16.142 5.651v27.849h16.333l16.284-16.963c27.024 8.855 57.091 17.963 66.455 17.963h148.472c18.661 0 33.456-15.129 33.456-33.79v-.42c0-18.662-14.795-33.791-33.457-33.791"
  })));
};
export default SvgLogo;